import NumberFormat from './NumberFormat';

export default NumberFormat;
